export const convertEpochToUTC = (timestamp, format) => {
    if (timestamp === 0) {
        return '-';
    }

    // Create a date object in UTC from the timestamp
    const date = new Date(timestamp * 1000); // Assuming timestamp is in seconds

    let formattedDate = '';

    if (format === "DD-MM-YYYY") {
        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = date.getUTCFullYear();
        return `${day}-${month}-${year}`;
    }

    switch (format) {
        case 'DD/MM/YYYY, 24hrs, Leading zeros':
            formattedDate = date.toLocaleString('en-GB', {
                timeZone: 'UTC',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
            });
            break;

        case 'DD/MM/YYYY, 24hrs, No leading zeros':
            formattedDate = `${date.getUTCDate()}/${date.getUTCMonth() + 1}/${date.getUTCFullYear()} ${date.getUTCHours()}:${date.getUTCMinutes()}:${date.getUTCSeconds()}`;
            break;

        case 'MM/DD/YYYY, 24hrs, No leading zeros':
            formattedDate = `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()} ${date.getUTCHours()}:${date.getUTCMinutes()}:${date.getUTCSeconds()}`;
            break;

        case 'MM/DD/YYYY, AM/PM, No leading zeros':
            formattedDate = date.toLocaleString('en-US', {
                timeZone: 'UTC',
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                second: '2-digit',
                hour12: true,
            });
            break;

        case 'MM/DD/YYYY, 24hrs, Leading zeros':
            formattedDate = date.toLocaleString('en-US', {
                timeZone: 'UTC',
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
            });
            break;

        case 'DD/MM/YYYY, AM/PM, Leading zeros':
            const daydd = date.getUTCDate().toString().padStart(2, '0');
            const monthdd = (date.getUTCMonth() + 1).toString().padStart(2, '0');
            const yeardd = date.getUTCFullYear();
            const hourdd = date.getUTCHours();
            const hoursdd = hourdd % 12 || 12; 
            const amPmdd = hourdd >= 12 ? 'PM' : 'AM';
            const minutedd = date.getUTCMinutes().toString().padStart(2, '0');
            const seconddd = date.getUTCSeconds().toString().padStart(2, '0');
            formattedDate = `${daydd}/${monthdd}/${yeardd} ${hoursdd.toString().padStart(2, '0')}:${minutedd}:${seconddd} ${amPmdd}`;
            break;

        case 'DD/MM/YYYY, AM/PM, No leading zeros':
            const day2 = date.getUTCDate();
            const month2 = date.getUTCMonth() + 1;
            const year2 = date.getUTCFullYear();
            const hour2 = date.getUTCHours();
            const hours12 = hour2 % 12 || 12;
            const amPm = hour2 >= 12 ? 'PM' : 'AM';
            const minute2 = date.getUTCMinutes().toString().padStart(2, '0');
            const second2 = date.getUTCSeconds().toString().padStart(2, '0');
            formattedDate = `${day2}/${month2}/${year2} ${hours12}:${minute2}:${second2} ${amPm}`;
            break;

        case 'MM/DD/YYYY, AM/PM, Leading zeros':
            formattedDate = date.toLocaleString('en-US', {
                timeZone: 'UTC',
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true,
            });
            break;

        default:
            formattedDate = `${date.getUTCDate()}/${date.getUTCMonth() + 1}/${date.getUTCFullYear()}`;
    }

    return formattedDate;
};
